import { Country } from "country-state-city";

export default function LocationSection({ data, errors, onChange }) {
  const countries = Country.getAllCountries();

  return (
    <>
      <div>
        <label className="mb-1 block text-sm font-medium">
          Country<span className="text-red-500">*</span>
        </label>
        <select
          name="country"
          value={data.country}
          onChange={onChange}
          className={`w-full rounded-xl border p-3 ${
            errors.country ? "border-red-400" : "border-gray-300"
          }`}
        >
          <option value="">Select Country</option>
          {countries.map((c) => (
            <option key={c.isoCode} value={c.isoCode}>
              {c.name}
            </option>
          ))}
        </select>
        {errors.country && (
          <p className="mt-1 text-xs text-red-500">{errors.country}</p>
        )}
      </div>

      
    </>
  );
}
